import { SkeletonRows } from "./SkeletonRows.jsx";

export function EntityTableBodySkeleton({ count = 6 }) {
  return <SkeletonRows count={count} height={40} gap={8} style={{ padding: 20 }} />;
}
